import * as _ from 'lodash';

export const filterHelper = (filter = {}) => {
  const tempFilter = _.cloneDeep(filter);
  const {
    gps_status = [],
    dry_run = true,
    halted,
    source_zones_list = [],
    destination_zones_list = [],
    status,
    trip_type = [],
    vendor_list = [],
    customer_list = [],
    team_type = [],

    business_filter_type = [],
    engaged_by_list = [],
    customers = [],
    vendors = [],
  } = tempFilter;
  const filterParams = {
    ...(gps_status?.length && {
      gps_status,
    }),
    ...(source_zones_list?.length && {
      source_zones_list,
    }),
    ...(destination_zones_list?.length && {
      destination_zones_list,
    }),
    ...(trip_type?.length && {
      trip_type,
    }),
    ...(status && {
      status,
    }),
    ...(halted && {
      halted,
    }),
    ...(vendor_list?.length && {
      vendor_list,
    }),
    ...(customer_list?.length && {
      customer_list,
    }),
    ...(team_type?.length && {
      team_type,
    }),
    ...(business_filter_type?.length && {
      business_filter_type,
    }),
    ...(engaged_by_list?.length && {
      engaged_by_list,
    }),
    ...{
      dry_run,
    },
    ...(customers?.length && {
      customers,
    }),
    ...(vendors?.length && {
      vendors,
    }),
  };
  return filterParams;
};

// transform warehouses
export const transformWarehouses = (warehouses) => {
  if (!warehouses || !Object.keys(warehouses)?.length) return;

  const tempWarehouses = [];
  const loading_warehouse_data = warehouses?.loading_warehouse_data || {};
  const loading_city_data = warehouses?.loading_city_data || {};
  warehouses.loading_warehouse_ids.forEach((element) => {
    if (loading_warehouse_data[element]) {
      tempWarehouses.push(loading_warehouse_data[element]);
    }
    if (loading_city_data[element]) {
      tempWarehouses.push(loading_city_data[element]);
    }
  });
  return tempWarehouses;
};

export const encryptOrderCode = (orderCode) => {
  try {
    return btoa(orderCode); // Encode to Base64
  } catch (error) {
    console.error('Encryption error:', error);
    return orderCode;
  }
};

export const decryptOrderCode = (encryptedCode) => {
  try {
    return atob(encryptedCode); // Decode from Base64
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

export const getOrderDetailsPageOrderCode = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const orderCodeFromQuery = queryParams.get('order_code');
  const orderId = decryptOrderCode(orderCodeFromQuery);
  return orderId;
};
